// import { useMemo } from "react";

// const useButtonAccess = (accessRight) => {
//   return useMemo(() => {
//     if (!accessRight) {
//       return {
//         canRead: false,
//         canCreate: false,
//         canEdit: false,
//         canDelete: false,
//       };
//     }

//     return {
//       canRead: accessRight.read_access === 1,
//       canCreate: accessRight.create_access === 1,
//       canEdit: accessRight.edit_access === 1,
//       canDelete: accessRight.delete_access === 1,
//     };
//   }, [accessRight]);
// };

// export default useButtonAccess;

import { useMemo } from "react";

const useButtonAccess = (accessRight) => {
  return useMemo(() => {

    // FIX 1 — if null, undefined, false → return safe default
    if (!accessRight || typeof accessRight !== "object") {
      return {
        canRead: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
        canApprove: false,
      };
    }

    // FIX 2 — Convert non-numbers safely (avoid undefined or string issues)
    const read   = Number(accessRight.read_access)   === 1;
    const create = Number(accessRight.create_access) === 1;
    const edit   = Number(accessRight.edit_access)   === 1;
    const del    = Number(accessRight.delete_access) === 1;
    const approve  = Number(accessRight.approve_access) === 1;

    return {
      canRead: read,
      canCreate: create,
      canEdit: edit,
      canDelete: del,
      canApprove: approve,
    };
  }, [accessRight]);
};

export default useButtonAccess;
